import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './AuthContext';
import { APP_VERSION, buildStamp } from './appVersion';
import { register as registerSW } from './swRegistration';

console.log(`Site2Scope v${APP_VERSION} ${buildStamp()}`.trim());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

registerSW();
